<template>
    <div class="RegisterLayout">
        <div id="view">
            <router-view />
        </div>
    </div>
</template>
